// 價格歷史記錄相關設定
export const PRICE_HISTORY_CONFIG = {
  // 預設顯示天數
  DEFAULT_DAYS: 30,
  
  // 可選擇的時間範圍
  AVAILABLE_PERIODS: [
    { label: '7 天', value: 7, description: '最近一週' },
    { label: '14 天', value: 14, description: '最近兩週' },
    { label: '30 天', value: 30, description: '最近一個月' },
    { label: '90 天', value: 90, description: '最近三個月' }
  ],
  
  // 圖表顏色配置
  CHART_COLORS: {
    'Amazon': {
      border: 'rgba(255, 159, 64, 1)',
      background: 'rgba(255, 159, 64, 0.2)'
    },
    'Best Buy': {
      border: 'rgba(54, 162, 235, 1)',
      background: 'rgba(54, 162, 235, 0.2)'
    },
    'Newegg': {
      border: 'rgba(255, 99, 132, 1)',
      background: 'rgba(255, 99, 132, 0.2)'
    },
    'Walmart': {
      border: 'rgba(75, 192, 192, 1)',
      background: 'rgba(75, 192, 192, 0.2)'
    },
    'Target': {
      border: 'rgba(153, 102, 255, 1)',
      background: 'rgba(153, 102, 255, 0.2)'
    },
    'B&H': {
      border: 'rgba(255, 206, 86, 1)',
      background: 'rgba(255, 206, 86, 0.2)'
    }
  },
  
  // 通路圖示配置
  CHANNEL_ICONS: {
    'Amazon': 'fab fa-amazon',
    'Best Buy': 'fas fa-store',
    'Newegg': 'fas fa-laptop',
    'Walmart': 'fas fa-shopping-cart',
    'Target': 'fas fa-bullseye',
    'B&H': 'fas fa-camera'
  },
  
  // 圖表配置
  CHART_OPTIONS: {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: 'index'
    },
    elements: {
      point: {
        radius: 3,
        hoverRadius: 6
      },
      line: {
        tension: 0.1
      }
    }
  },
  
  // API 配置
  API: {
    ENDPOINT: '/products/{productId}/price-history',
    DEFAULT_PARAMS: {
      days: 7
    }
  }
}

// 根據天數獲取時間單位
export const getTimeUnit = (days) => {
  if (days <= 7) return 'day'
  if (days <= 30) return 'day'
  return 'week'
}

// 根據天數獲取顯示格式
export const getDisplayFormat = (days) => {
  if (days <= 7) return 'MMM dd HH:mm'
  if (days <= 30) return 'MMM dd'
  return 'MMM dd'
}

// 獲取通路顏色
export const getChannelColor = (channel, type = 'border') => {
  const colors = PRICE_HISTORY_CONFIG.CHART_COLORS[channel]
  if (!colors) {
    return type === 'border' ? 'rgba(128, 128, 128, 1)' : 'rgba(128, 128, 128, 0.2)'
  }
  return colors[type]
}

// 獲取通路圖示
export const getChannelIcon = (channel) => {
  return PRICE_HISTORY_CONFIG.CHANNEL_ICONS[channel] || 'fas fa-store'
}